export default {
  brand: {
    name: 'USFansLink',
  },
  nav: {
    home: 'Home',
    guide: 'USFans Spreadsheet Guide',
    shoppingGuide: 'Shopping Guide',
    categories: 'Categories',
    faq: 'FAQ',
    buyNow: 'Buy It Now',
    spread: 'USFans Spreadsheet',
  },
  lang: {
    label: 'Language',
    en: 'English',
    pl: 'Polski',
    es: 'Español',
    fr: 'Français',
  },
  trust: {
    independent: 'Independent Resource',
    updated: 'Updated Regularly',
    multilingual: 'Multilingual',
  },
  footer: {
    tagline: 'An independent informational resource for USFans spreadsheet users.',
    explore: 'Explore',
    shop: 'Shop Categories',
    mainSite: 'Visit Main Website',
    guide: 'Read the Guide',
    disclaimer: 'USFansLink is an independent informational resource. We do not guarantee the availability, authenticity, quality, price, shipping performance or safety of any third-party product, seller or service. Always verify important information independently before purchasing.',
    rights: 'All rights reserved.',
  },
};